











 
















const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MSTeamsProviderRowTeamMember",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamMemberIntegrations",
      "kind": "LinkedField",
      "name": "integrations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "MSTeamsIntegration",
          "kind": "LinkedField",
          "name": "msTeams",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TeamMemberIntegrationAuthWebhook",
              "kind": "LinkedField",
              "name": "auth",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IntegrationProviderWebhook",
                  "kind": "LinkedField",
                  "name": "provider",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "id",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamMember",
  "abstractKey": null
};

(node ).hash = "a110a0f3d0dc2d9e96701d2473b47b06";

export default node;
